module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/259-european-union-f3b3d39607f35ed574fefd384899145d.svg";